import EventDate from "../../components/event-date";

const EventDateContainer = <template>
  <EventDate @topic={{@outletArgs.topic}} />
</template>;

export default EventDateContainer;
